export default __webpack_public_path__ + "static/media/antelope-1-thumbnail.400a9d1e.jpg";